import tagsCheck from '../commonComponents/tagsCheck.vue'
import visitorRegistration from './visitorRegistration.vue'
import vendorRegistration from './vendorRegistration.vue'
export default {
  name: "user-registration",
  components:{tagsCheck,visitorRegistration,vendorRegistration},
  data(){
    return{
      userType:0, /*0 -- visitor,1 -- vendor*/
    }
  },
  mounted(){
     this.getUserType()
  },
  methods:{
    getUserType:function () {
      if((this.$root.adminInfo.permissionCodes && this.$root.adminInfo.permissionCodes.indexOf( 'M_AddVisitor' ) === -1) || !this.ApiService.fastRegistrationSet.Visitor){
        this.userType = 1
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/userRegistration.js